// Services/fetchUploadProductImage.js
import { RESTAURANTS } from "./Endpoints";
import { ApiRequestInterceptor } from "../Services/apiRequest";

export const fetchUploadProductImage = async ({ restauranteId, productName, file }) => {
  const method = "POST";

  // Paso 1: pedir signed URL
  const response = await ApiRequestInterceptor(
    RESTAURANTS.uploadProductImage,
    method,
    {
      restauranteId,
      productName,
      contentType: file.type,
    }
  );

  if (response.code !== 200) throw new Error("No se pudo obtener URL firmada");

  const { uploadUrl, imageUrl } = response.data;

  // Paso 2: subir a S3 directo
  await fetch(uploadUrl, {
    method: "PUT",
    headers: { "Content-Type": file.type },
    body: file,
  });

  return imageUrl;
};
